export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /~/d3-array/src/constant.js
// module id = Mrl5
// module chunks = 0